import { createContext, useContext, useEffect, useState, useCallback, useMemo } from "react";
import { api } from "@/lib/api";
import { dict } from "@/lib/i18n";

const LangCtx = createContext(null);
const AuthCtx = createContext(null);

export const LangProvider = ({ children }) => {
  const [lang, setLangState] = useState(localStorage.getItem("ayd_lang") || "es");
  const setLang = useCallback((l) => { localStorage.setItem("ayd_lang", l); setLangState(l); }, []);
  const t = useCallback((k) => dict[lang][k] ?? k, [lang]);
  useEffect(() => { document.documentElement.lang = lang; }, [lang]);
  const value = useMemo(() => ({ lang, setLang, t }), [lang, setLang, t]);
  return <LangCtx.Provider value={value}>{children}</LangCtx.Provider>;
};

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const refresh = useCallback(async () => {
    try { const { data } = await api.get("/auth/me"); setUser(data); }
    catch { try { const { data } = await api.post("/auth/refresh"); setUser(data); } catch { setUser(false); } }
  }, []);
  useEffect(() => { refresh(); }, [refresh]);
  const logout = useCallback(async () => { await api.post("/auth/logout"); setUser(false); }, []);
  const value = useMemo(() => ({ user, setUser, refresh, logout }), [user, refresh, logout]);
  return <AuthCtx.Provider value={value}>{children}</AuthCtx.Provider>;
};

export const useLang = () => useContext(LangCtx);
export const useAuth = () => useContext(AuthCtx);
